import styled from '@emotion/styled';

export const Wrapper = styled.div<{ clickable: boolean }>`
  position: relative;
  padding: 24px;
  border: ${(props) => `1px solid ${props.theme.color.light.shadeLighter}`};
  box-shadow: -1px 3px 16px rgba(149, 157, 165, 0.19);
  border-radius: 4px;
  display: flex;
  flex-direction: column;
  ${(props) => props.clickable && 'cursor: pointer'};
`;

export const Row = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const Icon = styled.div`
  color: ${(props) => props.theme.color.blue.default};
`;

export const Title = styled.div`
  font-weight: 700;
  font-size: 14px;
  margin-top: 12px;
`;

export const Text = styled.div`
  font-weight: 500;
  font-size: 13px;
  margin-top: 8px;
  margin-bottom: 16px;
`;

export const Button = styled.div`
  margin-top: auto;
`;

export const Checked = styled.div`
  width: 18px;
  height: 18px;
  border-radius: 50%;
  font-size: 13px;
  color: white;
  background-color: ${(props) => props.theme.color.blue.default};
  display: flex;
  justify-content: center;
  align-items: center;
`;
